"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataParser = /** @class */ (function () {
    function DataParser() {
    }
    Object.defineProperty(DataParser, "_ZENKAKU_REGEX", {
        get: function () {
            return /[Ａ-Ｚａ-ｚ０-９！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝]/g;
        },
        enumerable: false,
        configurable: true
    });
    DataParser.toHankaku = function (zenkakuStr) {
        if (zenkakuStr === void 0) { zenkakuStr = ''; }
        // 入力値の全角を半角の文字に置換
        return zenkakuStr
            .replace(DataParser._ZENKAKU_REGEX, function (s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
        })
            .replace(/[‐－―]/g, "-") // ハイフンなど
            .replace(/[～〜]/g, "~") // チルダ
            .replace(/　/g, " "); // スペース
    };
    return DataParser;
}());
exports.default = DataParser;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/data_parser.ts
// module id = j9C2
// module chunks = 1